<template>
  <svg viewBox="0 0 1200 240" preserveAspectRatio="xMidYMax slice" aria-hidden="true">
    <circle v-for="(s, i) in stars" :key="'s' + i" :cx="s[0]" :cy="s[1]" :r="s[2]" fill="#F6F1E7" opacity=".55" />
    <circle cx="1040" cy="52" r="20" fill="#F6F1E7" opacity=".9" />
    <circle cx="1050" cy="46" r="18" fill="#2F4A3A" />

    <path d="M0 200C160 168 300 186 450 176s300-30 450-14 240 22 300 14V240H0Z" fill="#26392E" />

    <g v-for="(t, i) in trees" :key="'t' + i" :transform="'translate(' + t.x + ' 220)'">
      <rect x="-3" y="-22" width="6" height="22" fill="#1C2A22" />
      <circle cx="0" :cy="-22 - t.r * 0.7" :r="t.r" :fill="t.fill" />
    </g>

    <g v-for="(h, i) in houses" :key="'h' + i" :transform="'translate(' + h.x + ' ' + (220 - h.h) + ')'">
      <path :d="'M-8 2 ' + h.w / 2 + ' ' + -h.roof + ' ' + (h.w + 8) + ' 2Z'" :fill="h.roofFill" stroke-linejoin="round"
        :stroke="h.roofFill" stroke-width="4" />
      <rect :width="h.w" :height="h.h" :fill="h.fill" />
      <rect v-for="(w, j) in h.windows" :key="j" :x="w[0]" :y="w[1]" width="14" height="14" rx="2"
        :fill="w[2] ? '#F2B98F' : '#34503F'" />
      <rect :x="h.w / 2 - 8" :y="h.h - 26" width="16" height="26" rx="3" fill="#1C2A22" />
    </g>
    <rect y="218" width="1200" height="22" fill="#1C2A22" />
  </svg>
</template>

<script>
// Deterministic layout so the skyline looks the same on every render
const HOUSE_SPECS = [
  [40, 90, 64], [180, 120, 84], [330, 80, 58], [470, 110, 90], [640, 96, 70],
  [790, 130, 92], [960, 88, 62], [1090, 110, 80],
];

export default {
  name: "IlloNeighborhood",
  data() {
    const fills = ["#2B4235", "#24382D", "#304A3B"];
    const roofs = ["#C26A35", "#4F7A5C", "#E0915F"];
    return {
      houses: HOUSE_SPECS.map(([x, w, h], i) => {
        const windows = [];
        for (let row = 0; row * 26 + 14 < h - 30; row++) {
          windows.push([12, 12 + row * 26, (i + row) % 3 !== 1]);
          windows.push([w - 26, 12 + row * 26, (i + row) % 2 === 0]);
        }
        return { x, w, h, roof: 26 + (i % 3) * 8, fill: fills[i % 3], roofFill: roofs[i % 3], windows };
      }),
      trees: [
        { x: 140, r: 18, fill: "#4F7A5C" }, { x: 425, r: 22, fill: "#6B8F71" }, { x: 605, r: 16, fill: "#4F7A5C" },
        { x: 925, r: 20, fill: "#6B8F71" }, { x: 1230, r: 18, fill: "#4F7A5C" },
      ],
      stars: [
        [80, 40, 1.6], [210, 70, 1.2], [360, 30, 1.8], [520, 60, 1.2], [690, 26, 1.5],
        [820, 74, 1.1], [930, 34, 1.6], [1150, 80, 1.3],
      ],
    };
  },
};
</script>
